const dev = process.env.NODE_ENV !== "production";

export const accessToken = "...";
export const siteId = process.env.REACT_APP_siteId;
//export const apiUrl = "https://localhost:44321/";
//export const apiUrl2 = "https://localhost:44351/";
//export const apiUrl = "https://api.bluebirdcms.net/";
//export const apiUrl2 = "https://bepolux-api.bluebirdcms.net/";

// export const apiUrl2 = dev
//   ? "http://localhost:44351/"
//   : "https://bepolux-api.bluebirdcms.net/";
// export const apiUrl = dev
//   ? "https://bluebirdcmsapi-staging.azurewebsites.net/"
//   : "https://api.bluebirdcms.net/";

export const apiUrl = process.env.REACT_APP_apiUrl;
export const apiUrl2 = process.env.REACT_APP_apiUrl2;
